module.exports = __webpack_public_path__ + "static/media/maternity7.679c76a5.jpg";